import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const etTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nimi (väikesed tähed, ilma erimärkideta)',
    add: 'Lisa',
    allowedFileTypes: 'Lubatud failitüübid',
    allowedFileTypesDescription:
      'Piirake lubatud failitüüpe (nt pilt/*, rakendus/pdf). Kõigi tüüpide lubamiseks jätke tühjaks.',
    allowMultipleFiles: 'Luba mitu faili',
    amountInCents: 'Summa sentides',
    basePrice: 'Baashind',
    bcc: 'BCC',
    brand: 'Kaubamärk',
    cc: 'CC',
    checkboxPlural: 'Märkeruut Väljad',
    checkboxSingular: 'Märkeruut',
    checkedByDefault: 'Vaikimisi kontrollitud',
    chooseConfirmationType:
      'Valige, kas kuvada pärast vormi esitamist lehel teade või suunata ümber teisele lehele.',
    condition: 'Seisund',
    confirmationMessage: 'Kinnitussõnum',
    confirmationType: 'Kinnituse tüüp',
    countryPlural: 'Riigi väljad',
    countrySingular: 'Riik',
    creditCard: 'Krediitkaart',
    customURL: 'Kohandatud URL',
    datePlural: 'Kuupäeva väljad',
    dateSingular: 'Kuupäev',
    defaultValue: 'Vaikeväärtus',
    divide: 'Jaga',
    documentToLinkTo: 'Dokument, millele linkida',
    doesNotEqual: 'Ei võrdu',
    emailFrom: 'Meil Saatjalt',
    emailPlural: 'Meiliväljad',
    emailsDescription:
      'Saatke vormi esitamisel kohandatud e-kirju. Kasutage komadega eraldatud loendeid, et saata sama meili mitmele adressaadile. Sellel vormil olevale väärtusele viitamiseks mähkige selle välja nimi topeltsulgudesse, st {{firstName}}. Saate kasutada metamärki {{*}} kõigi andmete väljastamiseks ja {{*:table}}, et vormindada need meilis HTML-tabelina.',
    emailSingular: 'Meil',
    emailTo: 'Saada meilile',
    equals: 'Võrdub',
    field: 'Väli',
    fields: 'Väljad',
    fieldWidth: 'Välja laius (protsentides)',
    hasAnyValue: 'Omab mingit väärtust',
    internalLink: 'Sisemine link',
    label: 'Silt',
    maxFileSize: 'Max faili suurus (baitides)',
    maxFileSizeDescription: 'Maksimaalne faili suurus baitides. Jätke piiranguteta tühjaks.',
    message: 'Sõnum',
    messageDescription: 'Sisestage sõnum, mis tuleks selles meilis saata.',
    messagePlural: 'Sõnumiplokid',
    messageSingular: 'Sõnum',
    mimeType: 'MIME tüüp',
    mimeTypePlural: 'MIME tüübid',
    mimeTypeSingular: 'MIME tüüp',
    multiply: 'Korrutada',
    numberPlural: 'Numbriväljad',
    numberSingular: 'Number',
    optionPlural: 'Valikud',
    optionSingular: 'Võimalus',
    paymentFieldPlural: 'Makseväljad',
    paymentFieldSingular: 'Makse',
    paymentProcessor: 'Makse töötleja',
    paymentStatus: 'Olek',
    placeholder: 'Kohatäide',
    priceConditions: 'Hinnatingimused',
    priceConditionsPlural: 'Hinnatingimused',
    priceConditionsSingular: 'Hind Seisukord',
    radioOptions: 'Raadio atribuutide valikud',
    radioPlural: 'Raadioväljad',
    radioSingular: 'Raadio',
    redirect: 'Ümbersuunamine',
    replyTo: 'Vasta',
    required: 'Nõutav',
    selectOptions: 'Valige Valikud',
    selectPlural: 'Valige Väljad',
    selectSingular: 'Valige',
    statePlural: 'Osariigi väljad',
    stateSingular: 'osariik',
    staticValue: 'Staatiline väärtus',
    subject: 'Teema',
    submitButton: 'Esita nupu silt',
    subtract: 'Lahutage',
    textareaPlural: 'Tekstiala väljad',
    textareaSingular: 'Tekstiala',
    textPlural: 'Tekstiväljad',
    textSingular: 'Tekst',
    title: 'Pealkiri',
    token: 'märk',
    uploadCollection: 'Laadi kogu üles',
    uploadCollectionDescription: 'Valige, millisesse üleslaadimiskogusse faile salvestada',
    uploadFieldPlural: 'Laadige väljad üles',
    uploadFieldSingular: 'Laadi üles',
    urlToRedirectTo: 'URL, kuhu ümber suunata',
    value: 'Väärtus',
    valueOfField: 'Välja väärtus',
    valueType: 'Väärtuse tüüp',
  },
}

export const et: PluginLanguage = {
  dateFNSKey: 'et',
  translations: etTranslations,
}
